import { render, staticRenderFns } from "./CandidateMoveModal.vue?vue&type=template&id=3df70dad&"
import script from "./CandidateMoveModal.vue?vue&type=script&lang=js&"
export * from "./CandidateMoveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports